"use client";

import { DrupalNode } from "next-drupal";
import Link from "next/link";
import React from "react";
import { motion } from "framer-motion";
import { resolveLink } from "@/utils";

interface CardProps {
  data: DrupalNode;
}

const CardWithDoubleBorder = ({ data }: CardProps) => {
  const isBlue = data?.field_background_color === "blue";
  const isWhite = data?.field_background_color === "white";
  const isGray = data?.field_background_color === "gray";
  const isDarkDray = data?.field_background_color === "dark_gray";

  const bgClass = isBlue
    ? "bg-[#003350]"
    : isWhite
      ? "bg-white"
      : isGray
        ? "bg-[#f9f9f9]"
        : isDarkDray
          ? "bg-mapGray"
          : "bg-white";

  return (
    <div
      className={`py-16 ${bgClass} relative mobileMax:py-6 betweenMobileTab:py-10 overflow-hidden`}
    >
      <div className="mini-container">
        <div className="flex flex-wrap justify-between box-border pledge-dashboard-cards">
          {data?.field_add_card.map(
            (dashboardCard: DrupalNode, index: number) => {
              return (
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 0,
                  }}
                  key={index}
                  className="remove-animation-fluctuation px-[15px] w-[32%] mobileMax:w-[47%] mobileMax:px-0 border-t border-b border-[#11375C] border-line"
                >
                  <div className="flex items-center flex-col box-border h-full w-full overflow-hidden  py-6 mobileMax:py-3">
                    {!Number.isNaN(Number(dashboardCard?.field_title)) ? (
                      <div className="min-h-[80px] min-w-[80px] bg-[linear-gradient(to_right,#8EBCE5,#11375C)] rounded-full overflow-hidden flex items-center justify-center mb-3 laptopMax:min-h-[55px] laptopMax:min-w-[55px]">
                        <div className="flex items-center justify-center  text-center text-[35px] rounded-full overflow-hidden min-h-[70px] min-w-[70px] laptopMax:min-h-[45px] laptopMax:min-w-[45px] bg-white font-bold leading-10 --font-poppins laptopMax:text-medium laptopMax:leading-7">
                          <p className="bg-[linear-gradient(to_right,#8EBCE5,#11375C)] text-clip">
                            {/* {num} */}
                            {dashboardCard?.field_title}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <h5 className="font-bold text-lg bg-[linear-gradient(to_right,#8EBCE5,#11375C)]  text-clip betweenMobileTab:text-[25px] mobileMax:text-medium">
                        {dashboardCard?.field_title}
                      </h5>
                    )}
                    <div
                      className={`--font-poppins ${
                        isBlue ? "text-white" : "text-[#003350]"
                      } text-center font-semibold text-xmedium mobileMax:text-xsmall leading-normal lieTablets:text-small`}
                      dangerouslySetInnerHTML={{
                        __html: dashboardCard?.field_description?.processed,
                      }}
                    />
                  </div>
                </motion.div>
              );
            },
          )}
        </div>
      </div>
      {/* buttons */}
      {data?.field_button && (
        <div className="pt-[82px]" id="pledge-submit">
          <div className="mini-container">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0,
              }}
              className="remove-animation-fluctuation px-[15px] mobileMax:px-0 flex justify-center mx-auto items-center mobileMax:flex-wrap mobileMax:w-full"
            >
              <Link
                href={resolveLink(data?.field_button[0]?.uri)}
                className="!px-8 !py-2 mx-4 mobileMax:mx-0 mobileMax:mb-2.5 laptop:max-w-[360px] w-full cursor-pointer block text-center rounded-[65px] justify-center text-medium text-white font-medium bg-[linear-gradient(to_right,#2F6CA4,#033756)] --font-poppins mobileMax:text-small"
              >
                {data?.field_button[0]?.title}
              </Link>
              <Link
                href={resolveLink(data?.field_button[1]?.uri)}
                className="!px-8 !py-2 mx-4 mobileMax:mx-0 mobileMax:mb-2.5 laptop:max-w-[360px] w-full cursor-pointer block text-center rounded-[65px] justify-center text-medium text-white font-medium bg-[linear-gradient(to_right,#2F6CA4,#033756)] --font-poppins mobileMax:text-small"
              >
                {data?.field_button[1]?.title}
              </Link>
            </motion.div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardWithDoubleBorder;
